// The ONE centered-modal scaffold (scrim + dialog + head + body). The close
// discipline is a11y-load-bearing and must never fork: release the focus trap,
// remove scrim + modal, return focus to the opener (WCAG 2.4.3); Escape and a
// scrim click close too. Consumers: the navigator's debug "Why this source?"
// dialog and the topbar help panel - both ride the same gps-modal classes.

import { el, button } from "../lib/dom.ts";
import { trapFocus } from "../lib/focusTrap.ts";
import { syncOverlayBackground } from "../lib/overlayBackground.ts";

export function openModal(
  titleText: string,
  build: (close: () => void) => HTMLElement,
  opts: { modalClass?: string } = {},
): void {
  const opener = document.activeElement as HTMLElement | null;
  const scrim = el("div", "gps-scrim");
  const modal = el("div", `gps-modal${opts.modalClass ? " " + opts.modalClass : ""}`);
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-label", titleText);
  let release: (() => void) | null = null;
  const close = (): void => {
    release?.();
    scrim.remove();
    modal.remove();
    syncOverlayBackground(); // un-inert the background BEFORE returning focus to it
    opener?.focus?.();
  };
  const closeBtn = button("gps-close", "Close", close);
  closeBtn.setAttribute("aria-label", `Close ${titleText}`);
  const head = el("div", "gps-modal-head");
  head.append(el("div", "gps-modal-title", titleText), closeBtn);
  const body = el("div", "gps-modal-body");
  body.append(build(close));
  modal.append(head, body);
  scrim.addEventListener("click", close);
  document.body.append(scrim, modal);
  syncOverlayBackground(); // inert the app behind the dialog
  const handle = trapFocus(modal, { initialFocus: closeBtn, onEscape: close });
  release = () => handle.release();
}
